/**
 * Format AI recommendation text for better readability
 * - Splits into paragraphs (by double line breaks)
 * - Makes text between ** bold
 * - Detects and formats Option C boxes
 */
export const formatRecommendation = (text) => {
  if (!text) return null;

  // Check if there's an Option C section
  const hasOptionC = text.includes('💡 Alternative Path Detected') || text.includes('💡 **Alternative Path Detected**') || text.includes('┌─');
  
  if (hasOptionC) {
    // Split at the Option C marker
    let beforeBox, boxContent;
    
    if (text.includes('💡 Alternative Path Detected')) {
      const splitPoint = text.indexOf('💡 Alternative Path Detected');
      beforeBox = text.substring(0, splitPoint);
      boxContent = text.substring(splitPoint);
    } else if (text.includes('💡 **Alternative Path Detected**')) {
      const splitPoint = text.indexOf('💡 **Alternative Path Detected**');
      beforeBox = text.substring(0, splitPoint);
      boxContent = text.substring(splitPoint);
    } else {
      // Old format with box characters
      const parts = text.split(/(?=┌─+┐)/);
      beforeBox = parts[0];
      boxContent = parts[1];
    }
    
    const result = [];
    
    // Format the synthesis paragraphs before the box
    if (beforeBox) {
      const synthesisParagraphs = beforeBox.split(/\n\n+/).filter(p => p.trim());
      synthesisParagraphs.forEach((para, idx) => {
        result.push(formatParagraph(para, idx));
      });
    }
    
    // Add the Option C box as a special element
    if (boxContent) {
      result.push({
        key: 'option-c-box',
        type: 'option-c-box',
        content: boxContent
      });
    }
    
    return result;
  }

  // No Option C - format normally
  const paragraphs = text.split(/\n\n+/).filter(p => p.trim());
  return paragraphs.map((paragraph, index) => formatParagraph(paragraph, index));
};

const formatParagraph = (paragraph, index) => {
  const cleanParagraph = paragraph.trim();

  // Extract bold text
  const parts = [];
  let currentText = cleanParagraph;
  let boldMatch;
  
  while ((boldMatch = currentText.match(/\*\*([^*]+)\*\*/))) {
    const beforeBold = currentText.substring(0, boldMatch.index);
    const boldText = boldMatch[1];
    
    if (beforeBold) {
      parts.push({ type: 'text', content: beforeBold });
    }
    parts.push({ type: 'bold', content: boldText });
    
    currentText = currentText.substring(boldMatch.index + boldMatch[0].length);
  }
  
  if (currentText) {
    parts.push({ type: 'text', content: currentText });
  }

  return {
    key: index,
    parts: parts.length > 0 ? parts : [{ type: 'text', content: cleanParagraph }],
    isQuestion: cleanParagraph.includes('?')
  };
};
